import { Injectable } from '@angular/core';
import { Api } from './api';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private api: Api) { }

  getAccount() {
    return this.api.get("/account", null).pipe(map(data => {
      return data;
    }));

  }

getReportExportAll() {
      return this.api.get("/report-exports", null).pipe(map(data => {
      return data;
    }));
}
createInvoice(reportExportData: any) {
  return this.api.postGenerate("/report-exports", reportExportData).pipe(
    map(response => response)
  );
}
getReportById(id: number) {
  return this.api.get(`/reports/${id}`, null).pipe(
    map(data => data)
  );
}

}
